// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".modal.modal--modalcheckoutproxy{padding:20px;max-width:90vw;max-height:95%;overflow-y:auto}@media(min-width: 768px){.modal.modal--modalcheckoutproxy{max-width:440px;padding:24px}}@media(min-width: 1024px){.modal.modal--modalcheckoutproxy{max-width:850px;padding:24px 24px 40px}.modal.modal--modalcheckoutproxy .modal__close{top:24px}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
